import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    TGetDashboardProductInventoryAPIResponse,
    TGetDashboardProductInventoryFilters,
    TGetDashboardProductPricingAPIResponse,
    TGetDashboardSilverProductPricingAPIResponse,
    TUpdateDashboarddMarketParams,
} from '~types/feat/dashboard';
import { MarketStatusReduxState, TDashboardReduxState } from '~types/redux/state';
import { MarketStatusEnum, MetalTypeEnum } from '~utils/enums';

const initialState: TDashboardReduxState = {
    loadings: {
        getDashboardProductPricing: false,
        getDashboardSilverProductPricing: false,
        getDashboardProductInventory: false,
        getDashboardGoldProductInventory: false,
        getDashboardSilverProductInventory: false,
        getDashboardMarketStatus: false,
        openDashboardMarket: false,
        closeDashboardMarket: false,
    },
    dashboardProductPricing: [],
    dashboardSilverProductPricing: [],
    dashboardGoldProductInventoryFilters: {
        branchName: '',
        branchCode: '',
        metalType: MetalTypeEnum.Gold,
    },
    dashboardSilverProductInventoryFilters: {
        branchName: '',
        branchCode: '',
        metalType: MetalTypeEnum.Silver,
    },
    dashboardGoldProductInventory: [],
    dashboardSilverProductInventory: [],
    dashboardMarketStatus: {
        status: MarketStatusEnum.Open,
        currentTime: '',
    },
    modals: {
        isMarketStatusOpenConfirmationModalOpen: false,
        isMarketStatusCloseConfirmationModalOpen: false,
    },
    errors: {
        getDashboardProductPricing: '',
        getDashboardSilverProductPricing: '',
        getDashboardProductInventory: '',
        getDashboardGoldProductInventory: '',
        getDashboardSilverProductInventory: '',
        getDashboardMarketStatus: '',
        openDashboardMarket: '',
        closeDashboardMarket: '',
    },
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        dashboardGetDashboardProductPricingAttempt: (state) => {
            state.loadings.getDashboardProductPricing = true;
            state.errors.getDashboardProductPricing = '';
        },
        dashboardGetDashboardProductPricingSuccess: (state, action: PayloadAction<TGetDashboardProductPricingAPIResponse>) => {
            state.loadings.getDashboardProductPricing = false;
            state.errors.getDashboardProductPricing = '';
            state.dashboardProductPricing = action.payload;
        },
        dashboardGetDashboardProductPricingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getDashboardProductPricing = false;
            if (action.payload) state.errors.getDashboardProductPricing = action.payload;
        },
        dashboardGetDashboardSilverProductPricingAttempt: (state) => {
            state.loadings.getDashboardSilverProductPricing = true;
            state.errors.getDashboardSilverProductPricing = '';
        },
        dashboardGetDashboardSilverProductPricingSuccess: (state, action: PayloadAction<TGetDashboardSilverProductPricingAPIResponse>) => {
            state.loadings.getDashboardSilverProductPricing = false;
            state.errors.getDashboardSilverProductPricing = '';
            state.dashboardSilverProductPricing = action.payload;
        },
        dashboardGetDashboardSilverProductPricingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getDashboardSilverProductPricing = false;
            if (action.payload) state.errors.getDashboardSilverProductPricing = action.payload;
        },
        dashboardGetDashboardProductInventoryAttempt: (state, action: PayloadAction<TGetDashboardProductInventoryFilters>) => {
            state.loadings.getDashboardProductInventory = true;
            state.errors.getDashboardProductInventory = '';
        },
        dashboardGetDashboardProductInventorySuccess: (
            state,
            action: PayloadAction<{
                data: TGetDashboardProductInventoryAPIResponse;
                metalType: MetalTypeEnum;
            }>
        ) => {
            state.loadings.getDashboardProductInventory = false;
            state.errors.getDashboardProductInventory = '';

            if (action.payload.metalType === MetalTypeEnum.Gold) {
                state.dashboardGoldProductInventory = action.payload.data;
            }

            if (action.payload.metalType === MetalTypeEnum.Silver) {
                state.dashboardSilverProductInventory = action.payload.data;
            }
        },
        dashboardGetDashboardProductInventoryFailure: (state, action: PayloadAction<{message: string, metalType: MetalTypeEnum}>) => {
            state.loadings.getDashboardProductInventory = false;

            if (action.payload.metalType === MetalTypeEnum.Gold) {
                state.errors.getDashboardGoldProductInventory =
                    action.payload.message;
            }

            if (action.payload.metalType === MetalTypeEnum.Silver) {
                state.errors.getDashboardSilverProductInventory =
                    action.payload.message;
            }
        },
        //params
        dashboardSetdashboardGoldProductInventoryFilters: (state, action: PayloadAction<TGetDashboardProductInventoryFilters>) => {
            state.dashboardGoldProductInventoryFilters = action.payload;
        },
        dashboardCleardashboardGoldProductInventoryFilters: (state) => {
            state.dashboardGoldProductInventoryFilters = initialState.dashboardGoldProductInventoryFilters;
        },
        dashboardClearDashboardProductInventory: (state) => {
            state.dashboardGoldProductInventory = initialState.dashboardGoldProductInventory;
            state.dashboardSilverProductInventory = initialState.dashboardSilverProductInventory;
        },
        dashboardSetdashboardSilverProductInventoryFilters: (state, action: PayloadAction<TGetDashboardProductInventoryFilters>) => {
            state.dashboardSilverProductInventoryFilters = action.payload;
        },
        dashboardCleardashboardSilverProductInventoryFilters: (state) => {
            state.dashboardSilverProductInventoryFilters = initialState.dashboardSilverProductInventoryFilters;
        },
        dashboardGetDashboardMarketStatusAttempt: (state) => {
            state.loadings.getDashboardMarketStatus = true;
            state.errors.getDashboardMarketStatus = '';
        },
        dashboardGetDashboardMarketStatusSuccess: (state, action: PayloadAction<MarketStatusReduxState>) => {
            state.loadings.getDashboardMarketStatus = false;
            state.errors.getDashboardMarketStatus = '';
            state.dashboardMarketStatus = action.payload;
        },
        dashboardGetDashboardMarketStatusFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getDashboardMarketStatus = false;
            if (action.payload) state.errors.getDashboardMarketStatus = action.payload;
        },
        dashboardIsMarketStatusOpenConfimationModalOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.isMarketStatusOpenConfirmationModalOpen = action.payload;
        },
        dashboardOpenDashboardMarketAttempt: (state, action: PayloadAction<TUpdateDashboarddMarketParams>) => {
            state.loadings.openDashboardMarket = true;
            state.errors.openDashboardMarket = '';
        },
        dashboardOpenDashboardMarketSuccess: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.openDashboardMarket = false;
            if (action.payload) state.errors.openDashboardMarket = action.payload;
        },
        dashboardOpenDashboardMarketFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.openDashboardMarket = false;
            if (action.payload) state.errors.openDashboardMarket = action.payload;
        },
        dashboardIsMarketStatusCloseConfirmationModalOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.isMarketStatusCloseConfirmationModalOpen = action.payload;
        },
        dashboardCloseDashboardMarketAttempt: (state, action: PayloadAction<TUpdateDashboarddMarketParams>) => {
            state.loadings.closeDashboardMarket = true;
            state.errors.closeDashboardMarket = '';
        },
        dashboardCloseDashboardMarketSuccess: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.closeDashboardMarket = false;
            if (action.payload) state.errors.closeDashboardMarket = action.payload;
        },
        dashboardCloseDashboardMarketFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.closeDashboardMarket = false;
            if (action.payload) state.errors.closeDashboardMarket = action.payload;
        },
    },
});

export default {
    actions: dashboardSlice.actions,
    reducers: dashboardSlice.reducer,
};
